import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ArrowUp } from 'lucide-react'

export function GoToTop() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          onClick={scrollToTop}
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.85 }}
          transition={{ duration: 0.2 }}
          className="fixed right-4 sm:right-6 go-to-top-float z-40 w-12 h-12 sm:w-11 sm:h-11 rounded-2xl bg-primary text-white shadow-card hover:bg-primary-light hover:scale-105 active:scale-95 transition-transform flex items-center justify-center min-h-[48px] min-w-[48px]"
          aria-label="Scroll to top"
        >
          <ArrowUp size={22} strokeWidth={2} />
        </motion.button>
      )}
    </AnimatePresence>
  )
}
